export default "__VITE_ASSET__DTEhSfv___"